import { render, staticRenderFns } from "./base-center.vue?vue&type=template&id=51279fe4&"
import script from "./base-center.vue?vue&type=script&lang=js&"
export * from "./base-center.vue?vue&type=script&lang=js&"
import style0 from "./base-center.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports